export interface IReconnectPolicy {
	getMaxRetries(): number;
	getDelay(retryCount: number): number;
	getPolicyName(): string;
}


export class LinearBackoffPolicy implements IReconnectPolicy {
    private baseDelay: number;
    private increment: number;
    private maxDelay: number;
    private maxRetries: number;

    constructor(baseDelay: number = 1000, increment: number = 1000, maxDelay: number = 15000, maxRetries: number = 10) {
        this.baseDelay = baseDelay;
        this.increment = increment;
        this.maxDelay = maxDelay;
        this.maxRetries = maxRetries;
    }

    getMaxRetries(): number {
        return this.maxRetries;
    }

    getDelay(retryCount: number): number {
        const delay = this.baseDelay + (this.increment * retryCount);
        return Math.min(delay, this.maxDelay);
    }

    getPolicyName(): string {
        return `LinearBackoff(base=${this.baseDelay}, inc=${this.increment}, max=${this.maxDelay}, maxRetries=${this.maxRetries})`;
    }
}

export class FixedIntervalPolicy implements IReconnectPolicy {
	private interval: number;
	private maxRetries: number;

	constructor(interval: number = 3000, maxRetries: number = 10) {
		this.interval = interval;
		this.maxRetries = maxRetries;
	}

	getMaxRetries(): number {
		return this.maxRetries;
	}

	getDelay(retryCount: number): number {
		return this.interval;
	}

	getPolicyName(): string {
		return `FixedInterval(interval=${this.interval}, maxRetries=${this.maxRetries})`;
	}
}


export class ExponentialBackoffPolicy implements IReconnectPolicy {
	private baseDelay: number;
	private maxDelay: number;
	private maxRetries: number;

	constructor(baseDelay: number = 1000, maxDelay: number = 30000, maxRetries: number = 10) {
		this.baseDelay = baseDelay;
		this.maxDelay = maxDelay;
		this.maxRetries = maxRetries;
	}

	getMaxRetries(): number {
		return this.maxRetries;
	}

	getDelay(retryCount: number): number {
		const delay = this.baseDelay * Math.pow(2, retryCount);
		return Math.min(delay, this.maxDelay);
	}

	getPolicyName(): string {
		return `ExponentialBackoff(base=${this.baseDelay}, max=${this.maxDelay}, maxRetries=${this.maxRetries})`;
	}
}
